import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ZpDataService } from './zp-data.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyConvertService {
  private _currencyLookup = {
    'gbp': { 'code': 'gbp', 'display': 'GBP (£)' },
    'usd': { 'code': 'usd', 'display': 'USD ($)' },
    'eur': { 'code': 'eur', 'display': 'EUR (€)' },
    'jpy': { 'code': 'jpy', 'display': 'JPY (円 / ¥)' },
    'aud': { 'code': 'aud', 'display': 'AUD (A$)' },
    'cad': { 'code': 'cad', 'display': 'CAD (C$)' },
    'chf': { 'code': 'chf', 'display': 'CHF (CHF)' },
    'cny': { 'code': 'cny', 'display': 'CNY (¥)' },
    'hkd': { 'code': 'hkd', 'display': 'HKD (HK$)' },
    'nzd': { 'code': 'nzd', 'display': 'NZD (NZ$)' },
  };
  private token: string;
  private apiUrl: string;
  public _currencyList = Object.values(this._currencyLookup);
  private _currencyData = null;
  private _defaultCurrency = 'gbp';
  private _cacheDate = () => new Date().toISOString().split('T')[0];
  constructor(private httpClient: HttpClient) {
    this.loadDataFromCache();
    if (!this._currencyData) {
      const self = this;
      window.setTimeout(function () {
        self.retrieveCurrencies(this._defaultCurrency).then(() => console.log('currency data loaded.'));
      }, 500);
    }
  }

  setConnectivity(token: string, apiUrl: string) {
    this.token = token;
    this.apiUrl = apiUrl;
  }
  getCurrency(value) {
    const parsed = value.split('-');
    if (parsed.length > 1) {
      return this._currencyLookup[parsed[0]];
    }
  }

  loadDataFromCache() {
    const cachedData = localStorage.getItem('_currencyData');
    if (cachedData) {
      if (cachedData.split('!', 1)[0] === this._cacheDate()) { // make sure the data isn't more than a day old.
        try {
          return this._currencyData = JSON.parse(cachedData.replace(this._cacheDate() + '!', ''));
        } catch (er) {
          console.log('couldn\'t retrieve cached currency data: ', er);
        }
      }
    }
  }
  cacheDataForSession(data) {
    if (data) {
      localStorage.setItem('_currencyData', this._cacheDate() + '!' + JSON.stringify(data));
    }
  }
  async retrieveCurrencies(defaultCurrency?: string) {
    // today's date in YYYY-MM-DD format
    // -- i don't need these now that we proxy on the server..
    // const date = new Date().toISOString().split('T')[0];
    // const params = new HttpParams().set('base', defaultCurrency ? defaultCurrency : 'GBP').set('v',date);
    // const options = { params };

    const options = {
      headers: {
        Authorization: this.token
      }
    };
    const response = await this.httpClient.get(this.apiUrl + '/api/currencyRates', options).toPromise();
    if (response.hasOwnProperty('success') && response.hasOwnProperty('rates')) {
      // @ts-ignore
      this._currencyData = response.rates;
      this.cacheDataForSession(this._currencyData);
    }
  }
  // convert value from currency to default currency.
  public convert(value: number, currency: string): number {
    let result = 0;
    if (!this._currencyData) {
      return value;
      console.log(Error('no currency data available'));
    }
    const rate = this._currencyData[currency.toUpperCase()];
    result = rate > 0 ? value / rate : 0;
    return result;
  }
  // used to determine whether currency conversion is even necessary
  public monetaryValueInDefaultCurrency(value: any): number {
    if (typeof value !== 'string') {
      return value;
    } else {
      let result = 0;
      const split = value.split('-');
      if (split.length > 1) {
        if (split[0] !== this._defaultCurrency) {
          result = this.convert(Number.parseFloat(split[1]), split[0]);
        } else {
          result = Number.parseFloat(split[1]);
        }
      } else {
        result = Number.parseFloat(value);
      }
      if(isNaN(result)) result = 0;
      return result;
    }
  }
}
